import ScoreRangeTable from './ScoreRangeTable';

export default ScoreRangeTable;
